import React from 'react';
import LegendHeader from '../legendHeader';
import TabsTable from '../tabs/tabsTable';
import AccordionTable from '../accordion/accordionTable';
import NoDataMessage from '../noDataMessage/noDataMessage';
import { openLinkParent } from '../../../functions/functions';
import HeaderTable from '../headerTable/headerTable';

/**
 * Componente optimizado para tablas de posiciones de basketball
 * Renderiza conferencias con divisiones y estadísticas de equipos
 */
export default function TableBasquetball({ dataTab1 }) {
  const stages = dataTab1?.baskStages || [];

  if (stages.length === 0 || !stages.some(stage => stage?.conferences?.length > 0)) {
    return <NoDataMessage title="Posiciones" />;
  }

  const getLast10Record = (recordDetails) => {
    const last10 = recordDetails?.find(record => record.name === "Last 10");
    return last10 ? `${last10.wins}-${last10.losses}` : '-';
  };

  const renderTable = (stage) => (
    <div className="table-content">
      {stage.conferences?.map((conference, confIndex) => (
        <div key={conference?.conferenceId || `conf-${confIndex}`} className="conference-section marginB10">
          <h3 className="conference-title">{conference?.name || 'Conference'}</h3>
          {conference?.divisions?.map((division, divIndex) => (
            <div key={division?.divisionsId || `div-${divIndex}`} className="division-section">
              <table className="positions-table">
                <thead>
                  <tr>
                    <th className="division-title">{division?.abbreviation || 'Division'}</th>
                    <th>W</th>
                    <th>L</th>
                    <th>PCT</th>
                    <th>GB</th>
                    <th>L10</th>
                    <th>STRK</th>
                  </tr>
                </thead>
                <tbody>
                  {division?.teams?.map((team, teamIndex) => {
                    const hasValidUrl = team?.url_wp && team.url_wp.trim().length > 0;
                    return (
                      <tr key={team?.teamId || `team-${teamIndex}`}>
                        <td className="team-item" {...(hasValidUrl && { onClick: () => openLinkParent(team.url_wp, false) })}>
                          <img
                            src={team?.image || 'assets/default.png'}
                            alt={`Logo ${team?.abbreviation || 'Team'}`}
                            loading="lazy"
                            onError={(e) => e.target.src = 'assets/default.png'}
                          />
                          <span className={hasValidUrl ? "team-abbreviation item-link" : "team-abbreviation"}>{team?.abbreviation || '-'}</span>
                        </td>
                      <td className="team-item">{team?.record?.wins || '-'}</td>
                      <td className="team-item">{team?.record?.losses || '-'}</td>
                      <td className="team-item">{team?.record?.percentage || '-'}</td>
                      <td className="team-item">{team?.division?.gamesBehind || '-'}</td>
                      <td className="team-item">{getLast10Record(team?.recordDetails)}</td>
                      <td className="team-item">{team?.streaks?.[0]?.games || '-'}</td>
                      </tr>
                    );
                  }) || []}
                </tbody>
              </table>
            </div>
          )) || []}
        </div>
      )) || []}
    </div>
  );

  return (
    <>
      <div className="positions-table__header">
        <HeaderTable title="Posiciones" />
        <LegendHeader
          text1="División cerrada"
          text2="Clinched Conference"
          text3="Clinched Playoff Berth"
        />
      </div>

      <div className="positions-table__sport">
        {stages.length === 2 ? (
          <TabsTable stages={stages} renderTable={renderTable} />
        ) : stages.length > 2 ? (
          <AccordionTable stages={stages} renderTable={renderTable} />
        ) : stages.length === 1 ? (
          renderTable(stages[0])
        ) : (
          <div className="no-data">No hay datos disponibles</div>
        )}
      </div>
    </>
  );
}